<template>
  <div class="layout-footer">
    <div class="footer-inner">
      <!-- Branding sinistra -->
      <div class="footer-brand">
        <span class="footer-product">Immigreer</span>
        <span class="footer-sep">{{ t('layout.footer.by', 'by') }}</span>
        <a
          href="https://www.codebase.it"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-company"
        >Codebase S.r.l.</a>
      </div>

      <!-- Link centrali -->
      <nav class="footer-links">
        <a
          href="https://www.immigreer.it"
          target="_blank"
          rel="noopener noreferrer"
        >immigreer.it</a>
        <span class="footer-dot" aria-hidden="true">·</span>
        <a
          href="https://www.codebase.it"
          target="_blank"
          rel="noopener noreferrer"
        >codebase.it</a>
        <span class="footer-dot" aria-hidden="true">·</span>
        <a
          href="mailto:info@codebase.it"
        >info@codebase.it</a>
      </nav>

      <!-- Badge app store -->
      <div class="footer-stores">
        <a
          href="https://play.google.com/store/apps/details?id=it.immigreer.mobile2"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-store"
          :aria-label="t('layout.footer.googlePlay', 'Disponibile su Google Play')"
        >
          <img
            src="/images/badge-google-play.png"
            :alt="t('layout.footer.googlePlay', 'Disponibile su Google Play')"
            class="store-google"
          >
        </a>
        <a
          href="https://apps.apple.com/us/app/immiapphr/id1611192623?itsct=apps_box_badge&amp;itscg=30200"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-store"
          :aria-label="t('layout.footer.appStore', 'Scarica su App Store')"
        >
          <img
            src="/images/badge-app-store.svg"
            :alt="t('layout.footer.appStore', 'Scarica su App Store')"
            class="store-apple"
          >
        </a>
      </div>

      <!-- Social + copyright destra -->
      <div class="footer-right">
        <a
          href="https://www.facebook.com/immigreersoftware"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-social"
          title="Facebook Immigreer"
        >
          <i class="pi pi-facebook" />
        </a>
        <span class="footer-copy">© {{ year }} Codebase S.r.l.</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const year = new Date().getFullYear()
</script>

<style scoped>
.layout-footer {
  background: var(--p-surface-card);
  border-top: 1px solid var(--p-content-border-color);
  padding: 0.75rem 1.5rem;
}

.footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
}

/* Brand */
.footer-brand {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.8125rem;
}

.footer-product {
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--p-primary-color);
}

.footer-sep {
  color: var(--p-text-muted-color);
  font-size: 0.75rem;
}

.footer-company {
  color: var(--p-text-muted-color);
  text-decoration: none;
  font-size: 0.8125rem;
  transition: color 0.15s;
}
.footer-company:hover {
  color: var(--p-primary-color);
}

/* Nav links */
.footer-links {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.footer-links a {
  font-size: 0.8125rem;
  color: var(--p-text-muted-color);
  text-decoration: none;
  transition: color 0.15s;
}
.footer-links a:hover {
  color: var(--p-primary-color);
}

.footer-dot {
  color: var(--p-text-muted-color);
  font-size: 0.75rem;
  opacity: 0.5;
}

/* Badge store */
.footer-stores {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.footer-store { display: inline-flex; border-radius: 8px; overflow: hidden; }
.store-google { height: 30px; width: auto; display: block; }
.store-apple { height: 24px; width: auto; display: block; }

/* Destra */
.footer-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.footer-social {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  color: var(--p-text-muted-color);
  text-decoration: none;
  transition: color 0.15s, background 0.15s;
}
.footer-social:hover {
  color: var(--p-primary-color);
  background: var(--p-surface-100);
}
.footer-social i {
  font-size: 0.875rem;
}

.footer-copy {
  font-size: 0.75rem;
  color: var(--p-text-muted-color);
  white-space: nowrap;
  padding-left: 0.25rem;
  border-left: 1px solid var(--p-content-border-color);
  margin-left: 0.25rem;
  line-height: 1.75rem;
}

@media (max-width: 640px) {
  .footer-links { display: none; }
  .footer-inner { justify-content: space-between; }
}
</style>
